import { useQuery } from '@tanstack/react-query';

import { getVenueLinks } from 'modules/shared-menu/api';

import { useMenuModuleContext } from '../context';

export const useSharedMenuLink = () => {
  const {
    venue: { id: venueId },
  } = useMenuModuleContext();

  const { data, isInitialLoading, error } = useQuery(
    ['shared-menu-link', venueId],
    async () => {
      const sharedMenuLinks = await getVenueLinks([venueId]);
      return sharedMenuLinks.venue_links.find(link => link.venue_id === venueId) ?? null;
    },
    {
      staleTime: Infinity,
      retry: false,
      enabled: !!venueId,
    },
  );
  return { sharedMenuLink: data, isSharedMenuLinkLoading: isInitialLoading, sharedMenuLinkError: error };
};
